@if (pdf || pdfLoading) {
  <div class="t-popup popup-graphs" style="display: block; height: 100%">
    <div class="popup-close"></div>

    <div class="popup-frame">
      <div class="popup-body">
        @if (reportid) {
          <h2>
            {{ "GUI.gastro.lab_results.title.lab_results" | translate }}
          </h2>
        }
        @if (assignable) {
          <button class="btn" (click)="assignToExam()">
            {{
              "GUI.gastro.lab_results.buttons.assign_to_this_exam" | translate
            }}
          </button>
        }

        <div class="graphs-container" style="max-width: 98%">
          @if (!pdfLoading && pdf != null) {
            <embed
              [src]="pdf"
              type="application/pdf"
              style="position: relative; width: 70vw; height: 80vh; z-index: 10"
            />
          }
          @if (pdfLoading) {
            <img
              src="../../assets/images/Wedges.svg"
              style="
                z-index: 0;
                margin-left: auto;
                margin-right: auto;
                position: absolute;
                left: 0;
                right: 0;
                top: 40vh;
              "
            />
          }
        </div>
        <button
          type="button"
          class="popup-close-button"
          (click)="closed.emit(false)"
        >
          Close
        </button>
      </div>
    </div>
  </div>
}
